export default __webpack_public_path__ + "static/media/Eye_7_F_C1.a31d489c.svg";